@import 'styles/mixins';
@import 'styles/blaze/mixins';

.fullScreenPreview {
  @include blur(15px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(243, 245, 246, 0.93);
  z-index: 1000;

  --chat-width: 330px;
  --sidebar-width: 230px;

  &[data-chat-open='false'] {
    --chat-width: 0px;
  }

  &[data-nextgen-chat='on'] {
    --chat-width: 360px;

    @media (max-width: $responsiveMedium) {
      --chat-width: 290px;
    }

    @media (max-width: $responsiveExtraSmall) {
      --chat-width: 0px;
    }
  }

  &[data-nextgen-chat='on'][data-chat-open='false'] {
    --chat-width: 0px;
  }

  @media (max-width: $responsiveMedium) {
    --chat-width: 290px;
  }

  @media (max-width: $responsiveExtraSmall) {
    --chat-width: 0px;
  }
}

.body {
  @include hide-scrollbar;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: var(--chat-width) 1fr var(--sidebar-width);
  gap: 0;
  overflow: auto;
  background: #fafafa;
}

.leftColumn {
  padding: 0;

  @media (max-width: $responsiveExtraSmall) {
    .body[data-chat-open='true'] & {
      display: none;
    }
  }
}

.chatContainer {
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 330px;
  background: transparent;
  transform: translateX(-100%);
  opacity: 0;

  &.isVisible {
    background: var(--light-80);
    transform: translateX(0);
    opacity: 1;
    @include container-shadow;

    [data-autopilot-system-redesign='on'] & {
      background: transparent;
      box-shadow: none;
    }
  }

  &:not(.isVisible) {
    background: transparent;
    transform: translateX(-100%);
    opacity: 0;
    box-shadow: none;
  }

  &[data-nextgen-chat='on'] {
    width: 360px;
    --chat-width: 360px;
    border-radius: 0;

    @media (max-width: $responsiveMedium) {
      --chat-width: 290px;
    }
  }
}

.centerColumn {
  grid-column: 2;
  height: 100%;
  position: relative;
  overflow: auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  background: #fafafa;
}

.carousel {
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &.isArticlePreview {
    max-width: 835px;
    width: 100%;
    align-self: center;
  }
}

.slide {
  position: absolute;
  inset: 0;
  display: block;
}

.carouselItem {
  @include hide-scrollbar;
  position: absolute;
}

.previewContentWrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.viewAsMenuAnchor {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);

  @media (max-width: $largeDevicesMinWidth) {
    right: auto;
    left: 0;
  }
}

.contentRatingContainer {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  z-index: 2;
}

.contentRating {
  margin-left: 0px;
}

.rightColumn {
  grid-column: 3;
  @include hide-scrollbar;
  position: relative;
  display: flex;
  align-items: start;
  justify-content: flex-end;
  overflow-y: auto;
  background: var(--light-60);
  border-left: 1px solid var(--dark-4);
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
